document.querySelectorAll(".audio-widget__text-accordion").forEach(wrapper => {
  const content = wrapper.querySelector(".audio-widget__extra-accordion-content");
  const toggle = wrapper.querySelector(".audio-widget__extra-accordion-toggle");

  if (content.scrollHeight > content.clientHeight) {
    toggle.hidden = false;
  }

  toggle.addEventListener("click", () => {
    content.classList.toggle("is-open");
    toggle.textContent = content.classList.contains("is-open")
      ? "Visa mindre"
      : "Visa mer";
  });
});
